const SidebarHr = () => (
  <hr
    style={{
      border: '1px solid #ffffff29',
      width: '80%',
      margin: 'auto',
    }}
  />
);

export default SidebarHr;
